import React, { Component } from 'react'

class MobileSearchDrawer extends Component {
	render() {
		return <div />
	}
}

export default MobileSearchDrawer
